export default __webpack_public_path__ + "static/unbanks-dd97cb959281166b294855de01391649.svg";